import { setStorageSelectedSalonNo, setStorageCustomerSalonNo } from './index';

export const addCheckoutAttributes = async (checkoutId, attributes, locale) => {
  const response = await fetch('/api/shopify/checkout/add-attributes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cartId: checkoutId, attributes, locale }),
  });

  if (response.status === 200) {
    // set(keys.SELECTED_SALON_NO, checkoutAttributes.input.customAttributes[0].value);
    // set(keys.CUSTOMER_SALON_NO, checkoutAttributes.input.customAttributes[1].value);
    setStorageSelectedSalonNo(locale, attributes[0].value);
    setStorageCustomerSalonNo(locale, attributes[1].value);
    return true;
  }

  return response.statusText;
};

export default addCheckoutAttributes;
